(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["g-announcement-custom"]) return;
  try {
    
  const announcement = document.querySelector('.g-announcement-custom');
  const overlay = document.querySelector('.g-overlay');

  const updateOverlayPosition = () => {
    if (!overlay) return;

    if (announcement) {
      overlay.style.top = `${announcement.offsetHeight}px`;
    } else {
      overlay.style.top = '0px';
    }
  };

  updateOverlayPosition();

  if (announcement) {
    const observer = new ResizeObserver(updateOverlayPosition);
    observer.observe(announcement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g-header"]) return;
  try {
    
	// ***CONSTANTS***
	const ANIMATION_DURATION = 300;
	const ANIMATION_DELAY = 10;

	const SELECTOR_DROPDOWN_TOGGLE = '.js-dropdown-toggle';
	const SELECTOR_HEADER_WRAPPER = '.js-header-wrapper-desktop';
	const SELECTOR_HEADER_DROPDOWN = '.c-header-dropdown';
	const SELECTOR_LINKLIST_ITEM = '.g-header__linklist__item';

	const SELECTOR_MOBILE_CONTENT = '.js-mobile-dropdown-content';
	const SELECTOR_MOBILE_DROPDOWN = '.js-mobile-dropdown';
	const SELECTOR_MOBILE_TOGGLE = '.js-mobile-dropdown-toggle';
  const SELECTOR_HEADER_WRAPPER_MOBILE = '.js-header-wrapper-mobile';

	const STATE_HAS_DROPDOWN_OPEN = 'has-dropdown-open';

	// ***DESKTOP DROPDOWN STATE***
	const DESKTOP_INITIAL_STATE = {
		currentOpenId: null,
	};

	let desktopState = { ...DESKTOP_INITIAL_STATE };

	// ***DESKTOP DROPDOWN FUNCTIONS***
	const openDesktopDropdown = function openDesktopDropdownNavigation(id) {
		const button = document.querySelector(`[aria-controls="${id}"]`);
		const dropdown = document.getElementById(id);
		const header = document.querySelector(SELECTOR_HEADER_WRAPPER);

		if (!dropdown || !button || !header) {
			return;
		}

		closeAllDesktopDropdowns();

		const headerHeight = header.offsetHeight;
		dropdown.style.top = `${headerHeight}px`;

		button.setAttribute('aria-expanded', 'true');
		dropdown.setAttribute('aria-hidden', 'false');
		header.classList.add(STATE_HAS_DROPDOWN_OPEN);

		desktopState.currentOpenId = id;
	};

	const closeDesktopDropdown = function closeDesktopDropdownNavigation(id, params) {
		const { skipFocus = false } = params || {};
		const button = document.querySelector(`[aria-controls="${id}"]`);
		const dropdown = document.getElementById(id);

		if (!dropdown || !button) {
			return;
		}

		button.setAttribute('aria-expanded', 'false');
		dropdown.setAttribute('aria-hidden', 'true');

		const hasOtherOpenDropdowns = Array.from(
		document.querySelectorAll(SELECTOR_HEADER_DROPDOWN)
		).some(d => d.id !== id && d.getAttribute('aria-hidden') === 'false');

		if (!hasOtherOpenDropdowns) {
			const header = document.querySelector(SELECTOR_HEADER_WRAPPER);
			if (header) {
				header.classList.remove(STATE_HAS_DROPDOWN_OPEN);
			}
		}

		if (!skipFocus) {
			button.focus();
		}

		if (desktopState.currentOpenId === id) {
			desktopState.currentOpenId = null;
		}
	};

	const closeAllDesktopDropdowns = function closeAllDesktopDropdownsNavigation() {
		document.querySelectorAll(SELECTOR_HEADER_DROPDOWN).forEach((dropdown) => {
			if (dropdown.getAttribute('aria-hidden') === 'false') {
				closeDesktopDropdown(dropdown.id, { skipFocus: true });
			}
		});
	};

	const onDesktopEscKey = function handleEscKeyPress(e) {
		if (e.key === 'Escape' && desktopState.currentOpenId) {
			closeDesktopDropdown(desktopState.currentOpenId);
		}
	};

	const initDesktopDropdown = function initDesktopDropdownNavigation() {
		const toggles = document.querySelectorAll(SELECTOR_DROPDOWN_TOGGLE);

		toggles.forEach((button) => {
			const id = button.getAttribute('aria-controls');
			const listItem = button.closest(SELECTOR_LINKLIST_ITEM);
			const dropdown = document.getElementById(id);

			if (!listItem || !dropdown) {
				return;
			}

			listItem.addEventListener('mouseenter', () => {
				openDesktopDropdown(id);
			});

			listItem.addEventListener('mouseleave', () => {
				closeDesktopDropdown(id, { skipFocus: true });
			});

			button.addEventListener('focus', () => {
				openDesktopDropdown(id);
			});

			dropdown.addEventListener('focusout', (e) => {
				setTimeout(() => {
					if (!dropdown.contains(document.activeElement) && document.activeElement !== button) {
						closeDesktopDropdown(id, { skipFocus: true });
					}
				}, ANIMATION_DELAY);
			});
		});

		document.addEventListener('keydown', onDesktopEscKey);
	};

	// ***MOBILE DROPDOWN FUNCTIONS***
	const openMobileDropdown = function openMobileDropdownDetails(details, content) {
		const header = document.querySelector(SELECTOR_HEADER_WRAPPER_MOBILE);

		details.classList.add('is-opening');
		details.open = true;
		content.style.height = '';
		content.style.opacity = '';

		if (header) {
			header.classList.add(STATE_HAS_DROPDOWN_OPEN);
		}

		requestAnimationFrame(() => {
			const contentHeight = content.scrollHeight;
			content.style.height = '0px';
			content.style.opacity = '0';
			content.offsetHeight;

			requestAnimationFrame(() => {
				content.style.height = `${contentHeight}px`;
				content.style.opacity = '1';
			});
		});

		setTimeout(() => {
			if (details.open) {
				content.style.height = 'auto';
			}
		}, ANIMATION_DURATION);
	};

	const closeMobileDropdown = function closeMobileDropdownDetails(details, content) {
		details.classList.remove('is-opening');
		const contentHeight = content.scrollHeight;
		content.style.height = `${contentHeight}px`;
		content.style.opacity = '1';
		content.offsetHeight;

		requestAnimationFrame(() => {
			content.style.height = '0px';
			content.style.opacity = '0';
		});

		setTimeout(() => {
			details.open = false;
		}, ANIMATION_DURATION);
	};

	const initMobileDropdown = function initMobileDropdownDetails() {
		const detailsElements = document.querySelectorAll(SELECTOR_MOBILE_DROPDOWN);

		detailsElements.forEach(details => {
			const summary = details.querySelector(SELECTOR_MOBILE_TOGGLE);
			const content = details.querySelector(SELECTOR_MOBILE_CONTENT);

			if (!summary || !content) {
				return;
			}

			summary.addEventListener('click', (e) => {
				e.preventDefault();

				if (details.open) {
					closeMobileDropdown(details, content);
				} else {
					openMobileDropdown(details, content);
				}
			});
		});
	};

	// ***INITIALIZE***
	const initAll = function initialize() {
		initDesktopDropdown();
		initMobileDropdown();
	};

	// Wait for DOM to be ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["personalize"] && !Shopify.designMode) return;
  try {
    
  const state = {
    errorIndex: -1,
  };

  function renderError(input, message) {
    // Simple error rendering - can be customized
    input.focus();

    state.errorIndex += 1;
    const container = input.closest('fieldset');
    const errorEl = document.createElement('p');
    errorEl.className = 'personalize__error';
    errorEl.textContent = message;
    errorEl.setAttribute('id', `personalize-error-${state.errorIndex}`);
    input.setAttribute('aria-describedby', `personalize-error-${state.errorIndex}`);
    input.setAttribute('aria-invalid', 'true');
    container.appendChild(errorEl);
  }

  function clearErrors(form) {
    const errors = form.querySelectorAll('.personalize__error');
    errors.forEach((error) => error.remove());

    const inputs = form.querySelectorAll('input, select, textarea');
    inputs.forEach((input) => {
      input.removeAttribute('aria-describedby');
      input.removeAttribute('aria-invalid');
    });
  }

  function validateTextInput(input) {
    const errorMessage = input.getAttribute('data-error');
    const errorMessageInvalid = input.getAttribute('data-error-invalid');
    const value = input.value.trim();
    const maxLength = parseInt(input.getAttribute('maxlength'), 10);

    if (value.length === 0 || value.length > maxLength) {
      renderError(input, errorMessage);
      return false;
    }

    if (!/^[A-Za-z0-9\s]+$/.test(value)) {
      renderError(input, errorMessageInvalid);
      return false;
    }

    return true;
  }

  function validateColorSelection(form) {
    const selectedColor = form.querySelector('.js-personalize-color-option:checked');
    const errorMessage = form.querySelector('.js-personalize-color-option').getAttribute('data-error');

    if (!selectedColor) {
      renderError(form.querySelector('.js-personalize-color-option'), errorMessage);
      return false;
    }
    return true;
  }

  function getVariantId() {
    // Get variant ID from query params, e.g. from /products/the-debrief-short-white?variant=43165250322547
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('variant');
  }

  function slideToLastSlide() {
    const slider = document.querySelector('c-slider');
    if (!slider) {
      return;
    }
    const slidesCount = slider.slideNodes.length;
    slider.embla.scrollTo(slidesCount - 1);
  }

  function openPersonalize() {
    const personalizeSection = document.querySelector('.js-personalize');
    const productForm = document.querySelector('.product-hero__content');
    if (!personalizeSection || !productForm) return;

    personalizeSection.setAttribute('aria-hidden', 'false');
    productForm.setAttribute('aria-hidden', 'true');

    document.body.classList.add('personalize-open');

    slideToLastSlide();

    /* Focus control */
    const firstInput = personalizeSection.querySelector('input, button, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (firstInput) {
      firstInput.focus();
    }

    const variantId = getVariantId();
    if (variantId) {
      const personalizeIdInput = personalizeSection.querySelector('.js-personalize-id');
      if (personalizeIdInput) {
        personalizeIdInput.value = variantId;
      }

      const personalizeVariant = document.querySelector(`.js-personalize-variant[data-variant-id="${variantId}"]`);

      if (personalizeVariant) {
        const personalPrice = personalizeVariant.getAttribute('data-price');
        const personalizePriceDisplay = personalizeSection.querySelector('.js-personalize-price');
        if (personalizePriceDisplay) {
          personalizePriceDisplay.textContent = personalPrice;
        }
      }
    }

    const monogramId = getUniqueId();
    const monogramIdInput = personalizeSection.querySelector('.js-personalize-uuid');
    if (monogramIdInput) {
      monogramIdInput.value = monogramId;
    }
  }

  function closePersonalize() {
    const personalizeSection = document.querySelector('.js-personalize');
    const productForm = document.querySelector('.product-hero__content');
    document.body.classList.remove('personalize-open');

    if (!personalizeSection || !productForm) return;

    personalizeSection.setAttribute('aria-hidden', 'true');
    productForm.setAttribute('aria-hidden', 'false');
    productForm.removeAttribute('aria-hidden');

    document.querySelector('.js-personalize-open').focus();
  }

  function onColorChange(event) {
    const selectedColor = event.target.value;
    const selectedServiceId = event.target.getAttribute('data-service-id');
    const childIdInput = document.querySelector('.js-personalize-child');
    const colorDisplay = document.querySelector('.js-personalize-color');
    const colorProperty = document.querySelector('.js-personalize-monogram-color');
    if (colorDisplay) {
      colorDisplay.textContent = selectedColor;
    }

    if (childIdInput) {
      childIdInput.value = selectedServiceId;
    }

    if (colorProperty) {
      colorProperty.value = selectedColor;
    }
  }

  function onSubmit(event) {
    // Prevent default submission to allow custom handling
    event.preventDefault();
    const form = event.currentTarget;

    const actionUrl = form.getAttribute('data-action');
    if (!actionUrl) return;

    const formData = new FormData(form);
    // Process formData to support the personalization service product with parent_id

    const formDataObj = Object.fromEntries(formData.entries());

    // Get selected service ID
    const selectedServiceId = form.querySelector('input[name="properties[Embroidery color]"]:checked').getAttribute('data-service-id');

    // Process the payload -- get all properties
    const {
      form_type,
      utf8,
      'product-id': _productId,
      'variant-id[]': _variantIds,
      ...mainProduct
    } = formDataObj;

    const payload = {
      items: [
        {
          ...mainProduct,
        },
        {
          id: selectedServiceId,
          parent_id: mainProduct.id,
          quantity: 1,
        },
      ],
    };

    fetch(actionUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
    .then(response => {
      if (response.ok) {
        // Optionally handle successful addition to cart (e.g., show a message or update cart UI)
        closePersonalize();
      } else {
        // Optionally handle errors
        alert('Error adding to cart');
      }
    })
    .catch(error => {
      alert('Error adding to cart', error);
    });
  }

  function validateForm() {
    const form = document.querySelector('.js-personalize-form');

    clearErrors(form);
    let isValid = true;

    const textInput = form.querySelector('#personalization-chars');
    if (textInput) {
      isValid = validateTextInput(textInput) && isValid;
    }

    isValid = validateColorSelection(form) && isValid;

    return isValid;
  }

  function getUniqueId() {
    return Math.random().toString(36).substr(2, 9);
  }

  function onSubmit(ev) {
    ev.preventDefault();

    const form = ev.currentTarget.closest('form');
    const textInput = form.querySelector('#personalization-chars');

    if (!validateForm()) {
      form.querySelectorAll('input').forEach((input) => {
        input.addEventListener('change', validateForm);
      });
      return false;
    } else {
      form.querySelectorAll('input').forEach((input) => {
        input.removeEventListener('change', validateForm);
      });
      cCart.submitForm(form);
      closePersonalize();
    }
  }

  function initPersonalize() {
    const toggle = document.querySelector('.js-personalize-open');
    const backButton = document.querySelector('.js-personalize-back');
    const colorOptions = document.querySelectorAll('.js-personalize-color-option');
    const form = document.querySelector('.js-personalize-form');

    if (!toggle || !backButton || !form) return;
    toggle.addEventListener('click', openPersonalize);
    backButton.addEventListener('click', closePersonalize);

    colorOptions.forEach((option) => {
      option.addEventListener('change', onColorChange);
    });

    form.setAttribute('novalidate', 'true');
    form.addEventListener('submit', onSubmit);
  }

  initPersonalize();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	const handleIntersection = (entries, observer) => {
		if (!entries[0].isIntersecting) return;

		observer.unobserve(productRecommendationsSection);

		const url = productRecommendationsSection.dataset.url;

		fetch(url)
			.then((response) => response.text())
			.then((text) => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('.product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					productRecommendationsSection.innerHTML = recommendations.innerHTML;
					cItemCardForm.init();
				}
			})
			.catch((e) => {
				console.error(e);
			});
	};

	const productRecommendationsSection = document.querySelector(
		'.product-recommendations'
	);

	const observer = new IntersectionObserver(handleIntersection, {
		rootMargin: '0px 0px 200px 0px',
	});

	observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
